import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-wrapper-validation-action',
  templateUrl: './wrapper-validation-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WrapperValidationActionComponent {}
